enum ActionTypes {
  /**
   * @deprecated In favor of LOAD_PAGINATED_NOTIFICATIONS_REQUEST and LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST
   * for site-wide alert acknowledgement feature
   */
  LOAD_RECENT_NOTIFICATIONS_REQUEST = 'LOAD_RECENT_NOTIFICATIONS_REQUEST',
  /**
   * @deprecated In favor of LOAD_PAGINATED_NOTIFICATIONS_SUCCESS and LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS
   * for site-wide alert acknowledgement feature
   */
  LOAD_RECENT_NOTIFICATIONS_SUCCESS = 'LOAD_RECENT_NOTIFICATIONS_SUCCESS',
  /**
   * @deprecated In favor of LOAD_PAGINATED_NOTIFICATIONS_FAILURE and LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE
   * for site-wide alert acknowledgement feature
   */
  LOAD_RECENT_NOTIFICATIONS_FAILURE = 'LOAD_RECENT_NOTIFICATIONS_FAILURE',

  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST',
  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS',
  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE',

  LOAD_PAGINATED_NOTIFICATIONS_REQUEST = 'LOAD_PAGINATED_NOTIFICATIONS_REQUEST',
  LOAD_PAGINATED_NOTIFICATIONS_SUCCESS = 'LOAD_PAGINATED_NOTIFICATIONS_SUCCESS',
  LOAD_PAGINATED_NOTIFICATIONS_FAILURE = 'LOAD_PAGINATED_NOTIFICATIONS_FAILURE',

  ACKNOWLEDGE_NOTIFICATION_REQUEST = 'ACKNOWLEDGE_NOTIFICATION_REQUEST',
  ACKNOWLEDGE_NOTIFICATION_SUCCESS = 'ACKNOWLEDGE_NOTIFICATION_SUCCESS',
  ACKNOWLEDGE_NOTIFICATION_FAILURE = 'ACKNOWLEDGE_NOTIFICATION_FAILURE',
  SET_PENDING_ACKNOWLEDGEMENT = 'SET_PENDING_ACKNOWLEDGEMENT',
  REMOVE_PENDING_ACKNOWLEDGEMENT = 'REMOVE_PENDING_ACKNOWLEDGEMENT',

  BULK_ACKNOWLEDGE_NOTIFICATIONS_REQUEST = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_REQUEST',
  BULK_ACKNOWLEDGE_NOTIFICATIONS_SUCCESS = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_SUCCESS',
  BULK_ACKNOWLEDGE_NOTIFICATIONS_FAILURE = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_FAILURE',

  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_PAGINATED_NOTIFICATIONS = 'SET_PAGINATED_NOTIFICATIONS',
  /**
   * @deprecated In favor of SET_PAGINATED_NOTIFICATIONS and SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS for site-wide alert
   * acknowledgement feature
   */
  SET_RECENT_NOTIFICATIONS = 'SET_RECENT_NOTIFICATIONS',
  SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS = 'SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS'
}

export default ActionTypes;
